import PageTemplate from '../components/PageTemplate';

const GenerosityPage = () => (
  <PageTemplate
    page="generosity"
    pageName="Generosity"
    tagline="The gift that multiplies when given."
    icon="❤️"
    accentColor="#E91E63"
    about={{
      title: 'Generosity: The Highest Return Investment',
      paragraph1: 'True wealth is measured by how much you give, not how much you accumulate. Generosity isn\'t just charity — it\'s a philosophy, a practice, and ultimately a way of being in the world.',
      paragraph2: 'The Village Investors community believes that a generous spirit creates the conditions for abundance to flow — for individuals, families, and entire communities.',
      points: [
        'Strategic philanthropy and impact giving',
        'Building a culture of generosity at home',
        'Community investment and mutual aid',
        'The psychology and joy of giving',
      ]
    }}
  />
);

export default GenerosityPage;
